<template>
  <div>
    <el-row :gutter="30">
      <el-col class="box" :span="24">
        <div class="list__header">
          <p class="list__title">
            {{ getRouteName($route) }}
          </p>
          <search-list-form v-model="filters.selected.search"
                            @submit="fetchData"/>
        </div>
        <el-table :data="data"
                  highlight-current-row
                  v-loading="listLoading"
                  class="list__table"
                  style="width: 100%;">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table :data="props.row.registrations"
                        class="list__table"
                        style="width: 100%;">
                <el-table-column prop="id" label="id" width="80"/>
                <el-table-column prop="email" label="email"/>
                <el-table-column prop="name" label="imię i nazwisko"/>
                <el-table-column prop="date_of_birth" label="data ur." width="100"/>
                <el-table-column label="akcje" width="150" class="pull-right">
                  <template slot-scope="scope" class="pull-right">
                    <el-button type="danger"
                               size="small"
                               title="Usuń tę rezerwację"
                               @click="handleDelete(scope.$index, scope.row, props.row.registrations)"><i
                      class="el-icon-delete"></i>
                    </el-button>
                  </template>
                </el-table-column>

              </el-table>
            </template>
          </el-table-column>
          <el-table-column prop="id" label="id" width="80"/>
          <el-table-column prop="event" label="wydarzenie"/>
          <el-table-column prop="date" label="data"/>
          <el-table-column prop="hour_from" label="godzina"/>
          <el-table-column prop="registered_number" label="zapisanych"/>
          <el-table-column prop="number_of_seats" label="liczba miejsc"/>
          <el-table-column label="opcje" width="150" class="pull-right">
            <template slot-scope="scope" class="pull-right">
              <el-button size="small"
                         @click="downloadCSV(scope.row)"
                         title="Eksportuj">
                <i class="el-icon-download"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-col :span="24" class="list__pagination">
          <el-pagination layout="prev, pager, next"
                         @current-change="handlePageChange"
                         :page-size="pageSize" :total="count"/>
        </el-col>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { Occurrence, Registration } from '@/api/'
import ListFilterComponent from '@/components/ListFilterComponent'
import axios from 'axios'

export default {
  data () {
    return {
      filters: {
        available: [],
        selected: {}
      },
      data: [],
      listLoading: false,
      service: Occurrence,
      count: 0,
      pageSize: 0
    }
  },
  methods: {
    async handleDelete (index, row, registrations) {
      await this.$confirm(this.$i18n.t('deleteConfirmation'), this.$i18n.t('delete'), {
        type: 'warning'
      })

      this.listLoading = true
      await Registration.delete(row.id)

      this.listLoading = false
      this.$message({
        message: 'Element został usunięty',
        type: 'success'
      })

      registrations.splice(index, 1)
    },
    handlePageChange (val) {
      this.page = val
      this.fetchData()
    },
    downloadCSV (obj) {
      const url = this.service.exportUrl(obj.id)
      axios({
        url: url,
        method: 'GET',
        responseType: 'blob', // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${obj.event}_${obj.date}.csv`)
        document.body.appendChild(link)
        link.click()
      })
    },
    setFilter (filter) {
      this.page = 1
      const key = filter.query_param
      const value = filter.value
      this.$set(this.filters.selected, key, value)
      this.fetchData()
    },
    fetchData () {
      let params = {
        page: this.page,
        ...this.filters.selected
      }
      this.listLoading = true
      this.service.fetch({}, { params }).then(response => {
        this.count = response.data.count
        this.pageSize = response.data.page_size
        this.data = response.data.results
        this.listLoading = false
      })
    },
  },
  mounted () {
    this.fetchData()
  },
  components: {
    ListFilterComponent
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// RegistrationsList.vue?0ef10275